/**
 * src/three/config.js
 */
export const T3 = {
  COLS: 8,
  ROWS: 8,
  LAYERS: 5,
  BRICK_W: 1.12,
  BRICK_H: 1.12,
  BRICK_D: 1.12,
  BLOCK: 1.12,
  GAP: 0.05,
  WALL_Z: -8.0,
  HP_MIN: 6,
  HP_MAX: 12,
  DAMAGE_MIN: 18,
  DAMAGE_MAX: 28,
  FIRE_RATE: 0.085,
  LOOK_SENS: 0.0022,
  PITCH_MIN: -1.15,
  PITCH_MAX: 1.15,
  WORD_FLIGHT: 0.4,
  DMG_WORLD_H: 0.75,
  TOUCH_LOOK_SENS: 0.0048,

  // กระสุน — แม็กกล 100 นัด (unlimited เปิดอยู่ เปลี่ยน false เพื่อจำกัด)
  AMMO_UNLIMITED: true,
  AMMO_MAG: 100,
  AMMO_RESERVE: 200,

  // Rage meter
  RAGE_MAX: 100,
  RAGE_PER_HIT: 3.5,
  RAGE_PER_BREAK: 10,
  RAGE_IDLE_DRAIN: 6,
  BERSERK_DURATION: 4.8,
  BERSERK_FIRE_MULT: 0.52,
  BERSERK_DMG_BONUS: 8,

  // Combo
  COMBO_TIMEOUT: 1.15,

  // Feel
  HITSTOP_HIT: 0.028,
  HITSTOP_BREAK: 0.055,
  SHAKE_HIT: 0.018,
  SHAKE_BREAK: 0.045,
  SHAKE_BERSERK: 0.012,
  VIBRATE_BREAK: 36,
  VIBRATE_FINALE: [50, 40, 90],

  // Target bricks
  TARGET_CHANCE: 0.22,

  // หลังจบด่าน — กลับไปเดิมพัน
  // ใช้ลิงก์ของแบรนด์จากฐานข้อมูลตาม ?brand= ก่อน
  // ถ้าไม่มีค่อยใช้ ?redirect= หรือค่านี้
  RETURN_URL: '',
  RETURN_LABEL: 'กลับไปเล่นเกมเดิมพัน',

  // จุดเล็ง (NDC) — ลบ = ต่ำกว่ากลางจอ ต้องตรงกับ .crosshair top ใน CSS
  // top 54% → ndcY = 1 - 2*0.54 = -0.08
  AIM_NDC_Y: -0.08,
};

/** คำกระสุนที่เลือกได้ตอนเล่น (5 คำตั้งต้น) — ไม่ซ้ำกับ RAGE_PHRASES */
export const BULLET_CHOICES = [
  'ไอ้เหี้ย',
  'ควย!',
  'เย็ดแม่',
  'ไอ้สัส',
  'ชิบหาย!',
];

/** จำนวนคำตั้งต้น / รวมสูงสุด (ตั้งต้น + คำที่พิมพ์เพิ่ม) */
export const BULLET_BASE_COUNT = 5;
export const BULLET_MAX_COUNT = 10;

export const RAGE_PHRASES = [
  'ไอ้ชาติชั่ว', 'สันดาน!', 'ตายห่า!', 'อีดอก', 'ไอ้ส้นตีน', 'แม่ง!',
  'ไอ้โง่', 'เหี้ยเอ๊ย', 'สัส!', 'ไอ้ห่า', 'ห่าเอ๊ย', 'ไอ้ควาย',
  'ควาย!', 'ไอ้เวร', 'เวรเอ๊ย', 'ไอ้สัตว์', 'สัตว์!', 'ไอ้เลว',
  'เลว!', 'ไอ้กาก', 'กาก!', 'ไอ้บ้า', 'บ้าเอ๊ย', 'ไอ้เปรต',
  'เปรต!', 'ไอ้ชั่ว', 'ชั่ว!', 'ไอ้หน้าด้าน', 'หน้าด้าน!', 'ไอ้หน้าหี',
  'อัด!', 'แตก!', 'เละ!', 'พัง!', 'ยับ!', 'ย่อย!',
  'แหลก!', 'ระเบิด!', 'กระแทก!', 'ทุบ!', 'ฟาด!', 'ซัด!',
  'ปัง!', 'บูม!', 'ฉีก!', 'ฉับ!', 'กระทืบ!', 'ถีบ!',
  'โมโห!', 'โกรธ!', 'เดือด!', 'เดือดดาล!', 'หัวร้อน!', 'แค้น!',
  'ระบาย!', 'ปล่อย!', 'กรี้ด!', 'คำราม!', 'คำรามกู!', 'บ้าคลั่ง!',
  'โดน!', 'ตาย!', 'ตายซะ!', 'จบ!', 'จบเหอะ!', 'ไปตาย!',
  'ไปเลย!', 'นอน!', 'ล้ม!', 'ล่ม!', 'พังทลาย!', 'ถล่ม!',
  'โคตร!', 'โคตรเหี้ย!', 'โคตรสัส!', 'โหด!', 'แรง!', 'เต็มสูบ!',
  'ไม่ยั้ง!', 'ไม่สน!', 'ช่างแม่ง!', 'กูทนไม่ไหว!', 'พอเหอะ!', 'พอ!',
  'เย็ด!', 'เย็ดกู!', 'แม่งเอ๊ย!', 'สัสเอ๊ย!', 'เหี้ย!', 'ควยเอ๊ย!',
  'แหลกเป็นผุย!', 'เละเทะ!', 'พังยับ!', 'แตกกระจาย!', 'ร่วง!', 'หลุด!',
];

/** ข้อความปลดปล่อยตามคอมโบ */
export const RELEASE_MESSAGES = [
  { min: 3, text: 'เริ่มระบาย!' },
  { min: 6, text: 'โล่งขึ้น!' },
  { min: 10, text: 'ยังไม่พอ!' },
  { min: 15, text: 'เดือดจัด!' },
  { min: 22, text: 'ปล่อยหมดเลย!' },
  { min: 30, text: 'บ้าคลั่ง!' },
];

/** เป้าหมายบนอิฐ — แพ้พนัน/เสียเงิน (หยาบได้ สั้นพอดีกล่อง) */
export const TARGET_LABELS = [
  'สล็อตกินควย', 'โบนัสกาก', 'ทุนหมดสัส',
  'เสียพนันเหี้ย', 'หวยไม่ถูกห่า',   'บาคาร่าสัส', 'เครดิตหมดควย',
  'ห้องแดงสัส', 'แทงผิดแม่ง', 'แจ็คพอตกาก',
  'ฟรีสปินห่า', 'เกมกินตัง', 'ยอดแดงเหี้ย', 'แตกไม่มาสัส',
  'เสียยับควย', 'กองทุนหมดห่า', 'เจ้ามือเหี้ย', 'พนันกูสัส',
];

export const COLORS = {
  BG: 0x070504,
  FOG: 0x0c0706,
  LIGHT_WARM: 0xffe2a8,
  MUZZLE: 0xffcc88,
};
